import * as React from 'react';
import { Route, Routes } from 'react-router';
import { BlogPostPage } from './BlogPostPage';
import { BlogPostsPage } from './BlogPostsPage';
import { NotFoundPage } from '../NotFoundPage';

export const BlogPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<BlogPostsPage />} />
      <Route path=":post/" element={<BlogPostPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
